import { render } from "./Altrescat.vue?vue&type=template&id=7ef98f58&scoped=true"
const script = {}

import "./Altrescat.vue?vue&type=style&index=0&id=7ef98f58&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef98f58"]])

export default __exports__